import type { TablerIconsProps } from '@tabler/icons-react';

export function SmallXIcon({
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...rest}
		>
			<path
				d="M11 5L5 11M5 5L11 11"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
